// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Kwa-z","narrowOptionButtons":"Lwa-z","noOptions":"Mwa-z"};